<template>
  <div style="margin-top: 10px">
    <div
      class="filtering"
    >
      <div class="search-toggle">

        <p>{{ $t('SearchBy') }}</p>
        <div>
          <p
            :class="{ active2: toggleSearch === 'OrderNumber' }"
            @click="callToggle('OrderNumber')"
          >
            {{ $t('OrderNumber') }}
          </p>
          <p
            :class="{ active2: toggleSearch === 'CustomerName' }"
            @click="callToggle('CustomerName')"
          >
            {{ $t('CustomerName') }}
          </p>
          <p
            :class="{ active2: toggleSearch === 'ShippingNotes' }"
            @click="callToggle('ShippingNotes')"
          >
            {{ $t('ShippingNotes') }}
          </p>
        </div>
      </div>
      <div
        v-if="toggleSearch === 'OrderNumber'"
        style="display: flex; align-items: center"
      >
        <div>
          <div class="black">
            <b-icon-search
              v-if="searchOrderNumber == ''"
              class="search1"
              style="position: absolute; left: 5px; top: 12px"
            />
            <b-icon-x-circle
              v-else-if="searchOrderNumber != ''"
              class="search1"
              style="position: absolute; right: 20px; top: 12px; cursor: pointer"
              @click="searchOrderNumber = ''"
            />
            <input
              v-model="searchOrderNumber"
              type="text"
              autocomplete="off"
              name="search-box"
              :placeholder="$t('OrderNumber')"
              :style="getFilteredOrderNumber.length > 0? 'border-radius: 8px 8px 0px 0px' : ''"
              @keyup="inputChanged"
              @keydown.down="onArrowDown"
              @keydown.up="onArrowUp"
            >
          </div>
          <div
            v-if="getFilteredOrderNumber.length > 0"
            ref="scrollContainer"
            class="dropdrop"
            :style="getFilteredOrderNumber.length > 7 ? 'height: 210px' : 'height: auto'"
          >
            <div
              v-for="(result, index) in getFilteredOrderNumber"
              :key="index"
              ref="options"
              style="cursor: pointer"
              class="search-item"
              :class="{ 'is-active': index === arrowCounter }"
              @click="searchByOrderNumber(result);"
            >
              <p style="margin: 0">
                {{ result.orderNumber }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="toggleSearch === 'CustomerName'"
        style="display: flex; align-items: center"
      >
        <div>
          <div class="black">
            <b-icon-search
              v-if="searchClient == ''"
              class="search1"
              style="position: absolute; left: 5px; top: 12px"
            />
            <b-icon-x-circle
              v-else-if="searchClient != ''"
              class="search1"
              style="position: absolute; right: 20px; top: 12px; cursor: pointer"
              @click="searchClient = ''"
            />
            <input
              v-model="searchClient"
              type="text"
              autocomplete="off"
              name="search-box"
              :placeholder="$t('ClientName')"
              :style="getFirstNames.length > 0? 'border-radius: 8px 8px 0px 0px' : ''"
              @keyup="inputChangedClient"
              @keydown.down="onArrowDownClient"
              @keydown.up="onArrowUpClient"
            >
          </div>
          <div
            v-if="getFirstNames.length > 0"
            ref="scrollContainer"
            class="dropdrop"
            :style="getFirstNames.length > 7 ? 'height: 210px' : 'height: auto'"
          >
            <div
              v-for="(result, index) in getFirstNames"
              :key="index"
              ref="options"
              style="cursor: pointer"
              class="search-item"
              :class="{ 'is-active': index === arrowCounter }"
              @click="searchByCustomerName(result);"
            >
              <p style="margin: 0">
                {{ result.nameToDisplay }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="toggleSearch === 'ShippingNotes'"
        style="display: flex; align-items: center"
      >
        <div>
          <div class="black">
            <b-icon-search
              v-if="searchShipment == ''"
              class="search1"
              style="position: absolute; left: 5px; top: 12px"
            />
            <b-icon-x-circle
              v-else-if="searchShipment != ''"
              class="search1"
              style="position: absolute; right: 20px; top: 12px; cursor: pointer"
              @click="searchShipment = ''"
            />
            <input
              v-model="searchShipment"
              type="text"
              autocomplete="off"
              name="search-box"
              :placeholder="$t('ShippingNotes')"
              :style="getFilteredOrdersByShipment.length > 0? 'border-radius: 8px 8px 0px 0px' : ''"
              @keyup="inputChangedNotes"
              @keydown.down="onArrowDownNotes"
              @keydown.up="onArrowUpNotes"
            >
          </div>
          <div
            v-if="getFilteredOrdersByShipment.length > 0"
            ref="scrollContainer"
            class="dropdrop"
            :style="getFilteredOrdersByShipment.length > 7 ? 'height: 210px' : 'height: auto'"
          >
            <div
              v-for="(result, index) in getFilteredOrdersByShipment"
              :key="index"
              ref="options"
              style="cursor: pointer"
              class="search-item"
              :class="{ 'is-active': index === arrowCounter }"
              @click="searchByShipmentNotes(result);"
            >
              <p style="margin: 0">
                {{ result.notes }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        class="table__header"
        style="display:flex;flex-wrap:wrap; gap:10px;margin-bottom: 15px !important; justify-content: flex-start; align-items: flex-end !important;"
      >
        <b-form-group
          :label="$t('StartDate')"
        >
          <date-picker
            v-model="startDateSales"
            value-type="format"
            class="form-control"
            format="YYYY-MM-DD"
            type="date"
            :placeholder="$t('SelectD')"
            style="padding-left: 0px;"
          />
        </b-form-group>
        <b-form-group
          :label="$t('EndDate')"
        >
          <date-picker
            v-model="endDateSales"
            value-type="format"
            class="form-control"
            format="YYYY-MM-DD"
            type="date"
            :placeholder="$t('SelectD')"
            style="padding-left: 0px;"
          />
        </b-form-group>
        <b-form-group
          style="width:15%"
          :label="$t('SalesPerson')"
        >
          <vue-select
            v-model="salesManager"
            :options="getUsersMultipleRoles"
            :placeholder="$t('Select')"
            :reduce="(e) => e.userID"
            label="fullName"
            style="width:100%"
          />
        </b-form-group>
        <b-form-group
          style="width:15%"
          :label="$t('Amount')"
        >
          <vue-select
            v-model="paidQuantity"
            :options="paidQuantites"
            label="name"
            :reduce="(e) => e.value"
            :placeholder="$t('Select')"
            style="width:100%"
          />
        </b-form-group>
        <div style="display:flex;flex-direction:column;gap:10px;padding-bottom:5px;padding-left:10px;">
          <label>
            {{ $t('Documents') }}
          </label>
          <div style="display:flex;gap:5px">
            <button
              v-b-tooltip.hover="$t('DownloadPDF')"
              style="border: 0; width: 48px; height: 36px; background: #FF274F; border-radius: 5px; margin-right: 10px;"
              @click="downloadPDF"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="white"
                class="bi bi-file-earmark-pdf"
                viewBox="0 0 16 16"
              >
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                <path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z" />
              </svg>
            </button>
            <button
              v-b-tooltip.hover="$t('DownloadExcel')"
              style="border: 0; width: 48px;
                  height: 37px; background: #FF274F; border-radius: 5px;"
              @click="downloadEXCEL"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="white"
                class="bi bi-file-earmark-spreadsheet"
                viewBox="0 0 16 16"
              >
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h3v2H6zm4 0v-2h3v1a1 1 0 0 1-1 1h-2zm3-3h-3v-2h3v2zm-7 0v-2h3v2H6z" />
              </svg>
            </button>
            <button
              class="button"
              @click="generateNewTable"
            >
              {{ $t('Generate new table') }}
            </button>
          </div>
        </div>
      </div>
      <div
        style="width: 100%;  padding-top: 16px; margin-top: 15px; height: 72vh; overflow-y: scroll;"
        class="scroll"
      >

        <table
          ref="exportable_table"
          class="team_table"
        >
          <thead style="position: sticky; top: -20px">
            <tr>
              <th>
                {{ $t('No') }}
              </th>
              <th>
                {{ $t('OrderNumber') }}
              </th>
              <th>
                {{ $t('ClientName') }}
              </th>
              <th>
                {{ $t('OrderType') }}
              </th>
              <th>
                {{ $t('Price') }}
              </th>
              <th>
                {{ $t('ShipmentPrice') }}
              </th>
              <th>
                {{ $t('PaidP') }}
              </th>
              <th>
                {{ $t('PaidShipment') }}
              </th>
              <th>
                {{ $t('Price') }} + {{ $t('ShipmentPrice') }}
              </th>
              <th>
                {{ $t('PaidP') }} + {{ $t('PaidShipment') }}
              </th>
              <th>
                {{ $t('ShipmentCostCode') }}
              </th>
              <th>
                {{ $t('SalesPerson') }}
              </th>
              <th>
                {{ $t('Account') }}
              </th>
              <th>
                {{ $t('SalesDate') }}
              </th>
              <th>
                {{ $t('Created') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(selling,index) in getSellingReportGrouped"
              :key="selling.sellingId"
            >
              <td>
                {{ getSellingReportGroupedTotalItems - (page-1)*pageSize-index }}.
              </td>
              <td>
                {{ selling.orderNumber }}
              </td>
              <td>
                {{ selling.clientFullName }}
              </td>
              <td>
                {{ $t(selling.orderType) }}
              </td>
              <td>
                {{ selling.price ? numbersWithcomma(selling.price) : 0 }}€
              </td>
              <td>
                {{ selling.shipmentPrice ? numbersWithcomma(selling.shipmentPrice) : 0 }}€
              </td>
              <td>
                {{ selling.paidAmount ? numbersWithcomma(selling.paidAmount) : 0 }}€
              </td>
              <td>
                {{ selling.paidShipmentAmount ? numbersWithcomma(selling.paidShipmentAmount) : 0 }}€
              </td>
              <td>
                {{ numbersWithcomma(((selling.price || 0) + (selling.shipmentPrice || 0))) }}€
              </td>
              <td>
                {{ numbersWithcomma(((selling.paidAmount || 0) + (selling.paidShipmentAmount || 0))) }}€
              </td>
              <td>
                {{ selling.shipmentCostCode }}
              </td>
              <td>
                {{ selling.salesUserFullName }}
              </td>
              <td>
                {{ selling.paymentAccounts }}
              </td>
              <td>
                {{ selling.salesDate ? formatDate(selling.salesDate) : null }}
              </td>
              <td>
                {{ formatDate(selling.created) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <b-pagination
          v-if="getSellingReportGroupedTotalItems > 15"
          v-model="page"
          :total-rows="getSellingReportGroupedTotalItems"
          :per-page="pageSize"
          first-number
          last-number
          align="fill"
          prev-class="prev-itemi"
          next-class="next-itemi"
          class="mt-1 mb-0"
        >
          <template #prev-text>
            <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
          </template>
          <template #next-text>
            <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import jsPDF from 'jspdf';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import 'vue2-datepicker/index.css';
import 'jspdf-autotable';
import { client } from '@/domainConfig'

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      paidQuantity: null,
      paidQuantites: [
        {
          name: 'All paid',
          value: 'All paid',
        },
        {
          name: 'Partially paid',
          value: 'Partially paid',
        },
        {
          name: 'Nothing paid',
          value: 'Nothing paid',
        },
      ],
      salesManager: null,
      client: client.clientName,
      endDateSales: null,
      startDateSales: null,
      toggleSearch: 'OrderNumber',
      page: 1,
      pageSize: 15,
      searchOrderNumber: '',
      searchClient: '',
      searchOrderNumberId: null,
      searchClientId: null,
      arrowCounter: 0,
      enterPressed: false,
      skipWatch: false,
      searchShipment: null,
    };
  },
  computed: {
    ...mapGetters([
      'getSellingReportGrouped',
      'getSellingReportGroupedTotalItems',
      'getFilteredOrderNumber',
      'getFirstNames',
      'getTotalPagesSellingReport',
      'getUsersMultipleRoles',
      'getFilteredOrdersByShipment',
    ]),
  },
  watch: {
    page(value) {
      this.sellingReportGroupedByOrderNumber({
        startFilterSalesDate: this.startDateSales,
        endFilterSalesDate: this.endDateSales,
        salesUserId: this.salesManager,
        salesType: 'Material',
        orderId: this.searchOrderNumberId,
        clientId: this.searchClientId,
        filterAllPaid: this.paidQuantity === 'All paid' ? true : null,
        filterPartiallyPaid: this.paidQuantity === 'Partially paid' ? true : null,
        filterNothingPaid: this.paidQuantity === 'Nothing paid' ? true : null,
        pageNumber: value,
        pageSize: this.pageSize,
      });
    },
    searchShipment(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeLists();
        } else if (!this.enterPressed) {
          this.searchByShipmentCode(value);
        }
      }, 500);
    },
    searchOrderNumber(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeLists();
        } else if (!this.enterPressed) {
          this.loadOrderNumbers({
            salesType: 'Product',
            orderNumber: value,
          });
        }
      }, 500);
    },
    searchClient(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeLists();
        } else if (!this.enterPressed) {
          this.firstNames(value);
        }
      }, 500);
    },
  },
  mounted() {
    this.usersByMultipleRoles({
      status: true,
      object: ['SalesPerson', 'OnlineSales', 'Manager'],
    })
  },
  methods: {
    ...mapActions([
      'sellingReportGroupedByOrderNumber',
      'resetOrderNumberList',
      'firstNames',
      'resetFirstNames',
      'usersByMultipleRoles',
      'loadOrderNumbers',
      'searchByShipmentCode',
      'resetSearchByShipmentCode',
    ]),
    generateNewTable() {
      this.page = 1
      this.sellingReportGroupedByOrderNumber({
        startFilterSalesDate: this.startDateSales,
        endFilterSalesDate: this.endDateSales,
        salesUserId: this.salesManager,
        salesType: 'Material',
        orderId: this.searchOrderNumberId,
        filterAllPaid: this.paidQuantity === 'All paid' ? true : null,
        filterPartiallyPaid: this.paidQuantity === 'Partially paid' ? true : null,
        filterNothingPaid: this.paidQuantity === 'Nothing paid' ? true : null,
        clientId: this.searchClientId,
        pageNumber: this.page,
        pageSize: this.pageSize,
      });
    },
    async searchByOrderNumber(value) {
      this.searchOrderNumber = value.orderNumber;
      this.searchOrderNumberId = value.orderId
      this.skipWatch = true;
      this.resetOrderNumberList()
    },
    async searchByCustomerName(value) {
      this.searchClient = value.nameToDisplay;
      this.searchClientId = value.clientId
      this.skipWatch = true;
      this.resetFirstNames()
    },
    async searchByShipmentNotes(value) {
      this.searchShipment = value.notes;
      this.searchOrderNumberId = value.orderId
      this.skipWatch = true;
      this.resetSearchByShipmentCode()
    },
    onArrowDownClient(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getFirstNames.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUpClient(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    onArrowDownNotes(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getFilteredOrdersByShipment.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUpNotes(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    inputChangedNotes(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByShipmentNotes(this.getFilteredOrdersByShipment[this.arrowCounter])
        this.resetSearchByShipmentCode()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    inputChangedClient(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByCustomerName(this.getFirstNames[this.arrowCounter])
        this.resetFirstNames()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    onArrowDown(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getFilteredOrderNumber.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUp(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    inputChanged(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByOrderNumber(this.getFilteredOrderNumber[this.arrowCounter])
        this.resetOrderNumberList()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight;
      console.log(liH)
      this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
    },
    callToggle(value) {
      this.toggleSearch = value
      this.searchOrderNumber = ''
      this.searchClient = ''
      this.searchShipment = ''
      this.searchOrderNumberId = null
      this.searchClientId = null
      this.arrowCounter = 0
    },
    removeLists() {
      this.resetFirstNames()
      this.resetOrderNumberList()
      this.resetSearchByShipmentCode()
      this.searchOrderNumberId = null
      this.searchClientId = null
      this.arrowCounter = 0
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    numbersWithcomma(value) {
      const options = {
        style: 'decimal', // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
      return value.toLocaleString('en-US', options);
    },
    generateExcel(tableContent) {
      const { headers, body } = tableContent;
      const sheetData = [headers, ...body];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const excelData = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      return excelData;
    },
    downloadEXCEL() {
      this.page = 1
      this.sellingReportGroupedByOrderNumberPDF({
        startFilterSalesDate: this.startDateSales,
        endFilterSalesDate: this.endDateSales,
        salesUserId: this.salesManager,
        salesType: 'Material',
        filterAllPaid: this.paidQuantity === 'All paid' ? true : null,
        filterPartiallyPaid: this.paidQuantity === 'Partially paid' ? true : null,
        filterNothingPaid: this.paidQuantity === 'Nothing paid' ? true : null,
        orderId: this.searchOrderNumberId,
        clientId: this.searchClientId,
        pageNumber: this.page,
        pageSize: this.pageSize,
      }).then(() => {
        const tableContent = this.generateTableContent(this.getSellingReportGrouped);
        const totalPages = this.getTotalPagesSellingReport;
        const additionalPromises = [];
        for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
          additionalPromises.push(this.downloadPage(pageNumber));
        }

        Promise.all(additionalPromises).then((additionalTableContents) => {
          additionalTableContents.forEach((additionalTableContent) => {
            tableContent.body = tableContent.body.concat(additionalTableContent.body);
          });

          const excelData = this.generateExcel(tableContent);
          FileSaver.saveAs(excelData, 'GroupedSellingReport.xlsx');
        });
      })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },
    downloadPDF() {
      this.page = 1
      this.sellingReportGroupedByOrderNumberPDF({
        startFilterSalesDate: this.startDateSales,
        endFilterSalesDate: this.endDateSales,
        salesUserId: this.salesManager,
        salesType: 'Material',
        filterAllPaid: this.paidQuantity === 'All paid' ? true : null,
        filterPartiallyPaid: this.paidQuantity === 'Partially paid' ? true : null,
        filterNothingPaid: this.paidQuantity === 'Nothing paid' ? true : null,
        orderId: this.searchOrderNumberId,
        clientId: this.searchClientId,
        pageNumber: this.page,
        pageSize: this.pageSize,
      })
        .then(() => {
          const tableContent = this.generateTableContent(this.getSellingReportGrouped);

          const totalPages = this.getTotalPagesSellingReport;
          const additionalPromises = [];
          for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
            additionalPromises.push(this.downloadPage(pageNumber));
          }

          Promise.all(additionalPromises).then((additionalTableContents) => {
            additionalTableContents.forEach((additionalTableContent) => {
              tableContent.body.push(...additionalTableContent.body);
            });

            const footerIcon = 'data:image/png;base64,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'
            let xharraIcon
            if (this.client == 'DrenushaXharra') {
              xharraIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABqCAYAAAAvBQZbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOHSURBVHgB7ZwxTBRBFIYfxo5AaaMNlZhYSy+2RuxshILERkNi5xlKI3YmRBsTCqjsNKEVe6xJpKOysTxDjfczN95xrMzs3lf+X3I5suy8nfnemzd3FMyc3X50FmZqroVBsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSIjrVXfdvBGxtRFxZyFibrZqSByfRLzdifhxdPG64jy+H61RvN39iC/fL/9u703EvbsRve2Lv9e8Dz6Nxq+8jGq0zq/vUwyxuHLl7eWKVCAF1ERrJZ4/eCEtcHkpEBRPSVh9GJ3Q+N56/f16VpZYQbkiFVACc4X9HLz/Ob16jCb94knEg6U0fvnZ5TEfPqdXCT1bC8rx9K6qK82hibVBEn79HiR4/+r78rNaUK5IVaJ4vpW2ac0CJF3bTPfOz6aW0BXFmIx3q75S/vHtML2/Xh+tqYnlYbLEbkH4GGWRXTKfx73aTlXXNcZkPFWTaNNiMkpEHv+/batr7zbSz0re1k7UUt7ah0epzNXvlNVaKf3BfQeH6UXRnyIhmvfq5ugA+diLeLo5Wo+uaY1KkoRrB7agLPJ8S62nk3atZaPXNqrthTVM0yJEFiRh6uOan9YnxqtUwnP1VlIWqYz1hltUD5+v3FbqQ5KvfqPeOvkxqA2qEsXJW1oHXlc0D61F8TS/LCz3TR2oLSWKskhlTyiTbbZp/jynyTb1I1V37edJJS9LJHquYmhOOdHj1/fqD5hxyiL1QL208LZbNGe5aeFzs+0ODcXQKUq1CVWeWsXisF3kSu1IWaQmr16St1ZNVeo+iVcCtE2atqIqtulbShP94YlNnP4ZxdIu0+HTPx31yo5UbO39lLl82LQ9cJTlpp6ja9P0TQLNIZ/cHfriOHXftZUtLbrNd2RNTBU3KSsLnHLiFzg+GcWepJSs48LBVZnsGf9vNAb/GQ3CIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEuIvb40EKb9BjHQAAAAASUVORK5CYII='
            } else if (this.client == 'WaloneFashion') {
              xharraIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAABxCAYAAABP/1R5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANkSURBVHgB7Z0tbxVREIZPCa4BiUGhgAQNnmIbwKGKQxES/gRIPAmi9wcACbbFF81fwGCb6jaT9iTb7Tmze/aeZ9a8T3LN3q+9z8yZmf1I7s75w5fnSXTnVhIIEgshsRASCyGxEBILIbEQEgshsRASCyGxEBILIbEQEgshsRASCyGxEBILIbEQEgshsRASCyGxEBILIbEQEgshsRASCyGxEBILIbEQEgshsRASCyGxEBILIbEQEgshsRASC3E79eT4a0r3793c/u9/Sq8+pnR6lpr5/CGl18+vb/v0LaXNr9SM7dvPLynd2U3Ffdx7l3rRN2N//C5vtx80ljMHE/Di2c3t79+U5Uzx9En9fYcLAuXQV6y3cyVBU9h7SiLu7i4L1Nv9+nPHJ6knfcXaUv/zt/ycZYs9WvBEtAbq0YPLRwnbZysFHenfvI6cyO81yPBEGK2B8oJUK2Fb0F+s7WStSbUsX09EpiVQXhCO+pYBo79Yk/q9kgFWG+dkWa1pjbFAzWliFoDStGJ4ibAFzBzrNQLr6FPUmtaYuU3Mew1QBgxGrDWDWhZ4I0+mpWRMZbZlau011rBqzXZLuCMvb/TyxJmIlqZkr3080eRqALU1w4n1lpiXZXNKxRiviXlNcNP3oGAIJ9ZbZt6o1DrrGgf75fJi2R84uw5hT8K0zrRWImrd28OaWKkceNkPNa0MK7Z1pl1ymJopSVypvhqsWJNa+wHjmba1aY0ZTxsrzK5D+POx3pIbZtmSpjVm2Ki8BgmXAYMX68201lhylm2TrZmDK7HeaUpwdh0ScwWhNtPmI6elTav0eVMnZ+Damul7BaGGLb3aUl9yntbDvscLEji7DokRm5dfKZN6lIC5nwfPrkPiLiYGLUGXgKaViRMbMOJMEhjcOLHeTBtBcGBj7ysIXIprf3esWG+mJQmaXYfE3wlzGDPuXGOFEhQvdo1ysIkPZrzY6GUZOLsOWeemuMiluVLDXEds5OgT3LQy64g1qScBP9gCuEIZMHb0PwgMuvEYQmIhJBZCYiEkFkJiISQWQmIhJBZCYiEkFkJiISQWQmIhJBZCYiEkFkJiISQWQmIhJBZCYiEkFkJiISQWQmIhJBZCYiEkFkJiISQWQmIhJBZCYiEkFkJiISQWQmIhJBZCYiEuAC77yTB1S+AfAAAAAElFTkSuQmCC'
            } else if (this.client == 'FjollaNila') {
              xharraIcon = 'data:image/png;base64,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'
            } else if (this.client == 'ValdrinSahiti') {
              xharraIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAABuCAYAAAC9f+Q3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAU0SURBVHgB7Zw/aFNRFMZvxa00YwfbxckGOje7cVc3QXARXCwFx4qjWDdBOgkundwsuLbdW1ch3Vysg2NC58pHcsjp9eXl3Zd73jn2nR+U1jQJ+Mv3zj33z+vS1b2HV8HJzq3giOBihXCxQrhYIVysEC5WCBcrhIsVwsUK4WKFcLFCuFghXKwQLlYIFyuEixXCxQrhYoVwsUK4WCGaF7v9JIS9nRC2NkNW8L7nhyEcvA0WuB2a5vH9ENZWQ+gsh3D2I2RjeDn+jvc2QPOJHU0EbNwNWSGh5z+DBZoXO5j8xyFiZTlkg8SeZrwKFqB5sRd/pj/3MtbZzuRDam1iudg7Gethd1Jaztqa2AFLVDdTnaWyYkQq0E1srpaLBsKBjTIAdLqCEWuNcgxglPzvbU4s4Kldz1BnKfmtTizgAnL0s0gsPiz+gSmjI5ZmSWBRsXg9yomRNovQEcslLFoKqAwYmRgQ/38pILGe2DDtCsCinQEl3lAPC/S6Ai637kQBHwgSbyytQG+hO8cARh+IsfoK9MTmmNrSB2Iwsc0vdBO856wiFpc9VrD4QvaD3vg7ygoeN9TH2hA7a5ULI36/NxYIcRCIEkKvpY5gf3f6GqQXz8EVcfBNTbYNsZREegzbN6+fT1es3n0ef4+7ieNP48efvRk/tzuZLEA4flZMsZ7YuC7StBSbgvjCzy/3ZrdR8YoWpNNzj0+DNjYSC2hqCqkAKSxLm8EVLY7uuYJ4ACOpSN68S9jgihZHVyyX0u9NR/xOhZkYPgg+kBnDTmI56BLKzgfQNNhoGQA2xSKxONEyS67BrZgYm2IBtVM4jhQLNrYjW4Su2Ljl4n0qgZ42Fmx84AJ67RYYRiKpd4U4COW7uPg3vpDS7mRFq+iDMMKS+p8uQRopiRC99XT6O5pFYUqL77wk4LmYCOx/MdkZ6Is9/HB92bD/YraojUmvS4svBOTiyxD6B4/jOll2iAOXP9XlIzZthWyefAPoiy2a2pZBv9/9eD3dkFrWojWMPbHzdm35wIXXPno1Ta8hufZKQVliV5b/XQqE4G22CkZyc569rYG9xJbt2pbtcaFN42Xh/U7QRF8sPyRHrJfsKICiPS68B+ou0e/lv4EkARu3I1UdwOatEaAc8GkuLUMqYENs1TpbZcbF+1kkVim1NsQOK5SCtdVqe1jxInm/FzSwIfa8QmJTlgr55AHrCwrYLAVFnUHKUiHfTOwsq5QDG2KLamZ8iCNlqTClNxbCTlcQy41l0PZ4laXC0WX6SZvM2Ln7Ox7AuIw6p7YlbntKwI7YslUumvun7BjwZCtMb+2ILZraxlsxKXtcw+g4UsPYEVt0mZPQbo1dWeVtG7uJBTSAQfDw0vQeV4xtsb1NszdvzMOW2KKWq059jRk2n3Q7YkFRamlKmppY3gn8bn4X15bYosGp7l/O4AfrWp/YWQKqzrg4vMUatV3srMu9zsDFE/vLS0Hx43Xu4+KJvWi72FmXbJ3E8sFLoVWz1xUUyU1tteKVsUHbxYL4sq2TNl4GlE4l2hMbp6tOfeQrY0r32dpPbB0x/A+lHZ4EDW5eKUAZoBqL91I69W2/FKTWR14GFM/M2k9sauL4drfizR/2xPKNwNSBC2WAEvv1RPUIvT2xgJKWKoaf1VI+Om9TbJ2kIa1UBpTTCnRvR5oFjghB1FHC7fGQSjIN3Oihf9fMDcVmKbgBuFghXKwQLlYIFyuEixXCxQrhYoVwsUK4WCFcrBAuVggXK4SLFcLFCuFihXCxQrhYIVysEH8ByP7sod3WFwQAAAAASUVORK5CYII='
            } else if (this.client == 'MinnaFashion') {
              xharraIcon = 'data:image/png;base64,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'
            } else if (this.client == 'Development') {
              xharraIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABqCAYAAAAvBQZbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOHSURBVHgB7ZwxTBRBFIYfxo5AaaMNlZhYSy+2RuxshILERkNi5xlKI3YmRBsTCqjsNKEVe6xJpKOysTxDjfczN95xrMzs3lf+X3I5suy8nfnemzd3FMyc3X50FmZqroVBsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSIjrVXfdvBGxtRFxZyFibrZqSByfRLzdifhxdPG64jy+H61RvN39iC/fL/9u703EvbsRve2Lv9e8Dz6Nxq+8jGq0zq/vUwyxuHLl7eWKVCAF1ERrJZ4/eCEtcHkpEBRPSVh9GJ3Q+N56/f16VpZYQbkiFVACc4X9HLz/Ob16jCb94knEg6U0fvnZ5TEfPqdXCT1bC8rx9K6qK82hibVBEn79HiR4/+r78rNaUK5IVaJ4vpW2ac0CJF3bTPfOz6aW0BXFmIx3q75S/vHtML2/Xh+tqYnlYbLEbkH4GGWRXTKfx73aTlXXNcZkPFWTaNNiMkpEHv+/batr7zbSz0re1k7UUt7ah0epzNXvlNVaKf3BfQeH6UXRnyIhmvfq5ugA+diLeLo5Wo+uaY1KkoRrB7agLPJ8S62nk3atZaPXNqrthTVM0yJEFiRh6uOan9YnxqtUwnP1VlIWqYz1hltUD5+v3FbqQ5KvfqPeOvkxqA2qEsXJW1oHXlc0D61F8TS/LCz3TR2oLSWKskhlTyiTbbZp/jynyTb1I1V37edJJS9LJHquYmhOOdHj1/fqD5hxyiL1QL208LZbNGe5aeFzs+0ODcXQKUq1CVWeWsXisF3kSu1IWaQmr16St1ZNVeo+iVcCtE2atqIqtulbShP94YlNnP4ZxdIu0+HTPx31yo5UbO39lLl82LQ9cJTlpp6ja9P0TQLNIZ/cHfriOHXftZUtLbrNd2RNTBU3KSsLnHLiFzg+GcWepJSs48LBVZnsGf9vNAb/GQ3CIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEuIvb40EKb9BjHQAAAAASUVORK5CYII='
            } else if (this.client == 'GreenHouse') {
              xharraIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABqCAYAAAAvBQZbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOHSURBVHgB7ZwxTBRBFIYfxo5AaaMNlZhYSy+2RuxshILERkNi5xlKI3YmRBsTCqjsNKEVe6xJpKOysTxDjfczN95xrMzs3lf+X3I5suy8nfnemzd3FMyc3X50FmZqroVBsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSIjrVXfdvBGxtRFxZyFibrZqSByfRLzdifhxdPG64jy+H61RvN39iC/fL/9u703EvbsRve2Lv9e8Dz6Nxq+8jGq0zq/vUwyxuHLl7eWKVCAF1ERrJZ4/eCEtcHkpEBRPSVh9GJ3Q+N56/f16VpZYQbkiFVACc4X9HLz/Ob16jCb94knEg6U0fvnZ5TEfPqdXCT1bC8rx9K6qK82hibVBEn79HiR4/+r78rNaUK5IVaJ4vpW2ac0CJF3bTPfOz6aW0BXFmIx3q75S/vHtML2/Xh+tqYnlYbLEbkH4GGWRXTKfx73aTlXXNcZkPFWTaNNiMkpEHv+/batr7zbSz0re1k7UUt7ah0epzNXvlNVaKf3BfQeH6UXRnyIhmvfq5ugA+diLeLo5Wo+uaY1KkoRrB7agLPJ8S62nk3atZaPXNqrthTVM0yJEFiRh6uOan9YnxqtUwnP1VlIWqYz1hltUD5+v3FbqQ5KvfqPeOvkxqA2qEsXJW1oHXlc0D61F8TS/LCz3TR2oLSWKskhlTyiTbbZp/jynyTb1I1V37edJJS9LJHquYmhOOdHj1/fqD5hxyiL1QL208LZbNGe5aeFzs+0ODcXQKUq1CVWeWsXisF3kSu1IWaQmr16St1ZNVeo+iVcCtE2atqIqtulbShP94YlNnP4ZxdIu0+HTPx31yo5UbO39lLl82LQ9cJTlpp6ja9P0TQLNIZ/cHfriOHXftZUtLbrNd2RNTBU3KSsLnHLiFzg+GcWepJSs48LBVZnsGf9vNAb/GQ3CIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEuIvb40EKb9BjHQAAAAASUVORK5CYII='
            }
            const digitIcon = 'data:image/png;base64,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'
            const pdfDocument = this.generatePDF(tableContent, footerIcon, xharraIcon, digitIcon, 800);
            pdfDocument.save(`GroupedSellingReport-${moment().format('DD/MM/YYYY - hh:mm:s')}.pdf`);
          });
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
      this.totali = 0;
      this.totaliAndShipment = 0
      this.totaliPaid = 0;
      this.totaliPaidAndShipment = 0;
      this.totalShipment = 0
      this.totalShipmentPaid = 0
    },
    downloadPage(pageNumber) {
      return this.sellingReportGroupedByOrderNumberPDF({
        startFilterSalesDate: this.startDateSales,
        endFilterSalesDate: this.endDateSales,
        salesUserId: this.salesManager,
        salesType: 'Material',
        filterAllPaid: this.paidQuantity === 'All paid' ? true : null,
        filterPartiallyPaid: this.paidQuantity === 'Partially paid' ? true : null,
        filterNothingPaid: this.paidQuantity === 'Nothing paid' ? true : null,
        orderId: this.searchOrderNumberId,
        clientId: this.searchClientId,
        pageNumber,
        pageSize: this.pageSize,
      })
        .then(() => {
          return this.generateTableContent(this.getSellingReportGrouped);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },
    generateTableContent(items) {
      const headers = [
        `${this.$t('OrderNumber')}`,
        `${this.$t('ClientName')}`,
        `${this.$t('OrderType')}`,
        `${this.$t('Price')}`,
        `${this.$t('ShipmentPrice')}`,
        `${this.$t('PaidPrice')}`,
        `${this.$t('PaidShipment')}`,
        `${this.$t('ShipmentCostCode')}`,
        `${this.$t('SalesPerson')}`,
        `${this.$t('SalesDate')}`,
        `${this.$t('Created')}`,
      ];
      for (let i = 0; i < items.length; i++) {
        this.totali += items[i].price || 0;
      }

      for (let j = 0; j < items.length; j++) {
        this.totaliPaid += items[j].paidAmount || 0
      }

      for (let i = 0; i < items.length; i++) {
        this.totalShipment += items[i].shipmentPrice || 0;
      }
      for (let j = 0; j < items.length; j++) {
        this.totalShipmentPaid += items[j].paidShipmentAmount || 0
      }
      for (let i = 0; i < items.length; i++) {
        this.totaliAndShipment += items[i].price || 0;
        this.totaliAndShipment += items[i].shipmentPrice || 0;
      }
      for (let j = 0; j < items.length; j++) {
        this.totaliPaidAndShipment += items[j].paidAmount || 0
        this.totaliPaidAndShipment += items[j].paidShipmentAmount || 0
      }

      const body = items.map((item) => {
        return [
          item.orderNumber,
          item.clientFullName,
          item.orderType,
          item.price ? this.numbersWithcomma(item.price) : 0,
          item.shipmentPrice ? this.numbersWithcomma(item.shipmentPrice) : 0,
          item.paidAmount ? this.numbersWithcomma(item.paidAmount) : 0,
          item.paidShipmentAmount ? this.numbersWithcomma(item.paidShipmentAmount) : 0,
          item.shipmentCostCode,
          item.salesUserFullName || 'No sales person',
          this.formatDate(item.salesDate),
          this.formatDate(item.created),
        ]
      });
      return { headers, body };
    },
    generatePDF(tableContent, footerIcon, xharraIcon, digitIcon, customWidth) {
      const { headers, body } = tableContent;


      // eslint-disable-next-line new-cap
      const doc = new jsPDF({
        orientation: 'landscape', // Set the orientation to landscape if you want a wider document
        unit: 'pt', // Use points as the unit of measurement
      });

      // Set custom width after creating the doc instance
      doc.setProperties({
        format: [customWidth, doc.internal.pageSize.getHeight()], // Set custom width
      });
      const iconWidth = 90; // Adjust the width of the icon as needed
      const iconHeight = 120; // Adjust the height of the icon as needed
      const iconY = 0; // Adjust the vertical position of the icon (top)
      // Draw a blue background rectangle that spans the entire width of the paper
      const blueBackgroundX = 0;
      const blueBackgroundWidth = doc.internal.pageSize.getWidth();
      const blueBackgroundHeight = 65; // Adjust the height as needed
      doc.setFillColor(255, 255, 255); // Blue color
      doc.rect(blueBackgroundX, 0, blueBackgroundWidth, blueBackgroundHeight, 'F');

      // Add the logo image on top of the blue background on the top left
      const iconX = 40; // Adjust the horizontal position of the icon (left)
      doc.addImage(xharraIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);

      const staticContent = () => {
        // Draw blue background for the footer
        const blueBackgroundFooterX = 0;
        const blueBackgroundFooterY = doc.internal.pageSize.getHeight() - 45;
        const blueBackgroundFooterWidth = doc.internal.pageSize.getWidth();
        const blueBackgroundFooterHeight = 45;
        doc.setFillColor(255, 39, 79); // Blue color (RGB values)
        doc.rect(blueBackgroundFooterX, blueBackgroundFooterY, blueBackgroundFooterWidth, blueBackgroundFooterHeight, 'F');

        // Add URL
        let url;
        let address;
        if (this.client == 'DrenushaXharra') {
          url = 'www.drenushaxharra.com';
          address = 'Kostori, Entrance C, Prishtinë, 10000';
        } else if (this.client == 'FjollaNila') {
          url = 'www.fjollanila.com';
          address = 'Elena Gjika, Pejë 30000';
        } else if (this.client == 'ValdrinSahiti') {
          url = 'www.valdrinsahiti.com'
          address = 'Autostrada Prishtinë-Ferizaj, km i 2të, 10000'
        } else if (this.client == 'WaloneFashion') {
          url = 'www.walonefashion.com'
          address = 'PRISHTINE-FERIZAJ, Km7, Prishtina 10000'
        } else if (this.client == 'MinnaFashion') {
          url = 'www.minna.shop'
          address = 'PRISHTINE-FERIZAJ, km i 5të, Prishtina 10000'
        } else if (this.client == 'BliniFashion') {
          url = 'www.bliniofficial.com'
          address = 'Magjistralja Prishtinë-Ferizaj, Kosovo'
        } else {
          url = 'http://localhost:8080/';
          address = 'Spim Fashion Group';
        }
        const urlX = doc.internal.pageSize.getWidth() - 800
        const urlY = doc.internal.pageSize.getHeight() - 25;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(url, urlX, urlY, { align: 'left' });

        // Add address

        const addressX = doc.internal.pageSize.getWidth() - 800
        const addressY = doc.internal.pageSize.getHeight() - 10;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(address, addressX, addressY, { align: 'left' });

        const digitIconWidth = 50;
        const digitIconHeight = 20;
        const digitIconY = doc.internal.pageSize.getHeight() - 35;
        const digitIconX = doc.internal.pageSize.getWidth() - 120;

        // Add text before digitIcon
        const textBeforeDigitIcon = 'Powered By';
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        const textY = doc.internal.pageSize.getHeight() - 20;
        const textX = doc.internal.pageSize.getWidth() - 180;

        doc.text(textBeforeDigitIcon, textX, textY);

        // Add the digitIcon
        doc.addImage(digitIcon, 'PNG', digitIconX, digitIconY, digitIconWidth, digitIconHeight);
      };

      const billP = (this.totaliAndShipment - this.totaliPaidAndShipment).toFixed(2).toString();
      const billX = doc.internal.pageSize.getWidth() - 38;
      const billY = 105;
      doc.setFontSize(13);
      doc.setTextColor(0, 0, 0);
      doc.text(`${this.$t('BillR')} ((${this.$t('TotalPrice')} + ${this.$t('ShipmentPrice')}) - (${this.$t('TotalPaid')} + ${this.$t('PaidShipment')})): ${billP}`, billX, billY, { align: 'right' });

      // const totalX = doc.internal.pageSize.getWidth() - 38;

      // const totalP11t = this.totalShipmentPaid.toFixed(2).toString() || 0;
      // const totalY33t = 61;
      // doc.setFontSize(13);
      // doc.setTextColor(0, 0, 0);
      // doc.text(`${this.$t('TotalShipmentPaid')} : ${totalP11t}`, totalX, totalY33t, { align: 'right' });

      // const totalP11 = this.totalShipment.toFixed(2).toString() || 0;
      // const totalY33 = 80;
      // doc.setFontSize(13);
      // doc.setTextColor(0, 0, 0);
      // doc.text(`${this.$t('TotalShipment')} : ${totalP11}`, totalX, totalY33, { align: 'right' });


      // const totalP1 = this.totaliPaid.toFixed(2).toString() || 0;
      // const totalY3 = 100;
      // doc.setFontSize(13);
      // doc.setTextColor(0, 0, 0);
      // doc.text(`${this.$t('TotalPaid')} : ${totalP1}`, totalX, totalY3, { align: 'right' });

      // const total = this.totali.toFixed(2).toString() || 0;
      // const totalY = 120;
      // doc.setFontSize(13);
      // doc.setTextColor(0, 0, 0);
      // doc.text(`${this.$t('TotalPrice')} : ${total}`, totalX, totalY, { align: 'right' });

      // const totalP = this.totaliPaidAndShipment.toFixed(2).toString() || 0;
      // const totalPX = doc.internal.pageSize.getWidth() - 38;
      // const totalPY = 140;
      // doc.setFontSize(13);
      // doc.setTextColor(0, 0, 0);
      // doc.text(`${this.$t('TotalPaid')} + ${this.$t('PaidShipment')}:  ${totalP}`, totalPX, totalPY, { align: 'right' });

      // const total1 = this.totaliAndShipment.toFixed(2).toString() || 0;
      // const totalY1 = 160;
      // doc.setFontSize(13);
      // doc.setTextColor(0, 0, 0);
      // doc.text(`${this.$t('TotalPrice')} + ${this.$t('ShipmentPrice')}: ${total1}`, totalX, totalY1, { align: 'right' });
      // // Add the title
      const title = this.$t('GroupedSellingReport');
      const titleY = doc.internal.pageSize.getHeight() - 540;
      const titleX = doc.internal.pageSize.getWidth() - 38;
      doc.setFontSize(25);
      doc.setFont('Arial', 'bold');
      doc.setTextColor(11, 19, 84);
      doc.text(title, titleX, titleY, { align: 'right' });

      // Add the author
      doc.setFont('Arial', 'normal');

      // Add the author
      const authorX = 150;
      const authorY = 76;
      doc.setFontSize(22);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.$t('Spim Fashion')}`, authorX, authorY);

      const author3X = 40;
      const author3Y = 150;
      doc.setFontSize(15);
      doc.setFont('Arial', 'bold');
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.$t('From')}:`, author3X, author3Y);

      doc.setFont('Arial', 'normal');

      const author4X = 92;
      const author4Y = 150;
      doc.setFontSize(15);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.client}`, author4X, author4Y);
      const columnCount = headers.length;
      const columnWidth = doc.internal.pageSize.getWidth() / (columnCount + 1);
      const columnStyles = {};
      for (let i = 0; i < columnCount; i++) {
        columnStyles[i] = { columnWidth, halign: 'center', fillColor: [255, 255, 255] };
      }

      const totalShipmentRow = [
        '',
        '',
        '',
        '',
        {
          content: `${this.$t('TotalPrice')}`,
          styles: {
            fontStyle: 'bold',
            fillColor: [211, 211, 211],
          },
        },
        {
          content: `${this.$t('TotalShipment')}`,
          styles: {
            fontStyle: 'bold',
            fillColor: [211, 211, 211],
          },
        },
        {
          content: `${this.$t('TotalPaid')}`,
          styles: {
            fontStyle: 'bold',
            fillColor: [211, 211, 211],
          },
        },
        {
          content: `${this.$t('TotalShipmentPaid')}`,
          styles: {
            fontStyle: 'bold',
            fillColor: [211, 211, 211],
          },
        },
        '',
        '',
        '',
        '',
      ];
      const totalShipmentPaidRow = [
        '',
        '',
        '',
        '',
        this.totali.toFixed(2).toString() || 0,
        this.totalShipment.toFixed(2).toString() || 0,
        this.totaliPaid.toFixed(2).toString() || 0,
        this.totalShipmentPaid ? this.numbersWithcomma(this.totalShipmentPaid) : 0,
        '',
        '',
        '',
        '',
      ];

      body.push(totalShipmentRow);
      body.push(totalShipmentPaidRow);

      // Add the table
      const tableOptions = {
        startY: authorY + 100, // Adjust the vertical position of the table
        time: moment().format('DD-MM-YYYY'),
        head: [headers],
        body,
        headStyles: {
          fillColor: [234, 236, 240],
          textColor: [11, 19, 84],
          halign: 'left',
        },
        bodyStyles: {
          textColor: [26, 26, 26],
          lineWidth: 0.1,
          lineColor: [234, 236, 240],
        },
        columnStyles,
        afterPageContent: staticContent,
      };
      doc.autoTable(tableOptions);

      return doc;
    },
  },
}

</script>

<style scoped lang="scss">

.team_table td {
  padding: 10px 3px !important;
}

.buttons {
    width: 36px !important;
    height: 36px;
    display: flex;
    margin-right: 5px;
    border-radius: 6px !important;
    justify-content: center;
    border: #c3d0dd 1px solid;
    background-color: #e9ecef;
    align-items: center;
}
.year {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.dropdrop::-webkit-scrollbar {
  display: none;

}

.dropdrop {
  display: inline-block;
  overflow: auto;
  position: absolute;
  background: white;
  width: 227px;
  box-shadow: none;
}
table:hover {
  cursor: pointer;
}

input[name="search-box"] {
  display: block;
  max-width: 500px;
  width: 95%;
  padding: 0.5rem 1rem;
  padding-left: 25px;
}

.black {
  position: relative;
}

.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 400;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}

.search-item:last-child {
  border-bottom: none;
}

.search-item:hover {
  background: #82868c;
  color: white;
}
.form-control{
  width: 193px;
  border: none;
}
.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}

.active2 {
  font-weight: bold;
  color: $base-color;
}

@media screen and (min-width: 1340px) and (max-width: 1500px) {
  .main{
    padding: 90px 10px 15px 90px;
  }
}

@media screen and (max-width: 1200px) {
  .scroll {
    overflow-x: scroll;
  }
}

@media screen and (max-width: 1190px) {
  .main {
    padding: 90px 10px 15px 10px !important;
  }
}
@media screen and (max-width: 1340px){
  .main{
    padding: 90px 10px 15px 90px;
  }
}

.is-active {
  background-color: #dedede;
}
</style>
